<template>
  <div>
    <ul class="px-2 md:px-8 leading-tight" :class="setAlign()">
      <li
        v-for="fact in facts"
        :key="fact"
        class="font-headline text-base md:text-xl font-semibold my-4 md:my-8 flex items-center"
        :class="{ 'justify-end': align === 'right' }"
      >
        <font-awesome-icon
          v-if="align === 'left'"
          icon="check"
          class="text-rc-blue mr-4 xl:mr-8"
        />

        <div class="w-full">{{ fact }}</div>
        <font-awesome-icon
          v-if="align === 'right'"
          icon="check"
          class="text-h-orange md:ml-6 ml-4 xl:ml-8 lg:mr-0 md:-mr-4"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "RoHFactsList",
  props: {
    facts: {
      type: Array,
      default: () => [],
    },
    align: {
      type: String,
      default: "left",
    },
  },
  methods: {
    setAlign() {
      if (this.align === "right") {
        return "text-right";
      } else {
        return "text-left";
      }
    },
  },
};
</script>

<style lang="scss"></style>
